<template>
  <div class="flex min-w-0 flex-col gap-1">
    <span v-if="showLabel" class="text-xs text-muted-foreground">
      Title
    </span>
    <RouterLink v-if="taskRoute && !readonly" :to="taskRoute" class="line-clamp-2 font-medium text-foreground transition-colors hover:text-primary">
      {{ title }}
    </RouterLink>
    <span v-else class="line-clamp-2 font-medium text-foreground">
      {{ title }}
    </span>
    <div v-if="tags.length > 0" class="flex flex-wrap gap-1">
      <Badge v-for="tag in tags" :key="tag.id" variant="outline" :style="resolveTagStyle(tag)" class="max-w-40 gap-1.5 truncate text-[11px] font-medium">
        <span class="truncate">{{ tag.name }}</span>
      </Badge>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { Badge } from '@/components/ui/badge/index.js'

const props = defineProps({
  task: {
    type: Object,
    default: null,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [String, Object],
    default: null,
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
})

const title = computed(() => {
  if (typeof props.value === 'string' && props.value.trim() !== '') {
    return props.value
  }

  if (typeof props.task?.title === 'string' && props.task.title.trim() !== '') {
    return props.task.title
  }

  return 'Untitled task'
})

const tags = computed(() => {
  if (Array.isArray(props.task?.tags)) {
    return props.task.tags
  }

  if (Array.isArray(props.task?.cached?.tags)) {
    return props.task.cached.tags
  }

  return []
})

const taskRoute = computed(() => {
  const taskId = Number(props.task?.id)

  if (!Number.isInteger(taskId) || taskId <= 0) {
    return null
  }

  return {
    name: 'TaskShowPage',
    params: {
      task: taskId,
    },
  }
})

const resolveTagStyle = (tag) => {
  const color = String(tag?.color ?? '').trim()

  if (!/^#[0-9A-Fa-f]{6}$/.test(color)) {
    return {}
  }

  return {
    borderColor: color,
    color,
  }
}
</script>
